/**
 * What an upload button says while bytes are moving.
 *
 * A percentage wherever the browser can give one. Progress is the difference
 * between waiting and force-quitting on a connection slow enough to make
 * somebody doubt the app.
 */
export function uploadingLabel(percent: number | null): string {
  return percent === null ? 'Uploading…' : `Uploading ${String(percent)}%`
}
